import styled from '@emotion/styled';
import { getColor, getTextColor } from '../../style';

const TextLink = styled('a')<{ fontcolor?: string }>(
  {
    fontWeight: 600,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  ({ fontcolor }) => {
    return fontcolor === 'red' ? { ...getTextColor().RED } : { color: getColor().BRAND_1 };
  }
);

export default TextLink;
